// ref: https://github.com/streamich/react-use/blob/master/src/useBeforeUnload.ts
import { useCallback, useEffect } from 'react';

const useBeforeUnload = (enabled: boolean | (() => boolean) = true) => {
  const handler = useCallback(
    (event: BeforeUnloadEvent) => {
      const finalEnabled = typeof enabled === 'function' ? enabled() : true;

      if (!finalEnabled) {
        return;
      }

      event.preventDefault();
      event.returnValue = 'str';

      return 'str';
    },
    [enabled],
  );

  useEffect(() => {
    if (!enabled) {
      return;
    }

    window.addEventListener('beforeunload', handler);

    return () => window.removeEventListener('beforeunload', handler);
  }, [enabled, handler]);

  const cleanup = useCallback(() => {
    window.removeEventListener('beforeunload', handler);
  }, [handler]);

  return cleanup;
};

export default useBeforeUnload;
